<div class="vertical-container">
    <h1 style="font: 600 28px 'Poppins', sans-serif; max-width: 500px; text-align: center;">Dogo is packed with everything your need</h1>
    <br>
    <br>
    <div class="features-container">
        <div class="feature vertical-container gravity-center" *ngFor="let feature of features">
            <img [src]="feature.icon" [alt]="feature.title" />
            <h3>{{ feature.title }}</h3>
            <p>{{ feature.about }}</p>
        </div>
    </div>
</div>